/* Remove .no-js from html if JavaScript is enabled */
document.getElementsByTagName('html')[0].className = document.getElementsByTagName('html')[0].className.replace('no-js', "")+" js";

jQuery(document).ready(function($) {
    
    var novaGlobals = {};

    novaGlobals.$window           = $(window);
    novaGlobals.$html             = $('html');
    novaGlobals.$body             = $('body');
    novaGlobals.$wpadminbar       = $('#wpadminbar');

    /* Validation
    ---------------------------------------- */
    $('#form-contact').validate();

    $('#form-donate').validate();
    
    /* Sliders
    ---------------------------------------- */

    $( '.hero' ).flexslider({
        prevText: '<i class="icon-chevron-thin-left"></i>',
        nextText: '<i class="icon-chevron-thin-right"></i>'
    });

    $( '.latest-events' ).flexslider({
        prevText: '<i class="icon-chevron-thin-left"></i>',
        nextText: '<i class="icon-chevron-thin-right"></i>'
    });

    /* jQuery UI
    ---------------------------------------- */

    $( '#form-contact #department' ).selectmenu();
    $( '.donation-form .payment-length-selection' ).selectmenu();
    $('.widget-donate-form .payment-length-selection').selectmenu();
    $('#event-category').selectmenu();
    $('#event-time').selectmenu();

    /* Mobile Nav
    ---------------------------------------- */

    if( $(window).width() >= 960 ){
        $('.header-wrapper').removeClass('wrapper-flush');
    } else{
        $('.header-wrapper').addClass('wrapper-flush');
    }

    /* Screen WIdth */
    $(window).on('resize', function(event){

        if( $(window).width() == 960 ){
            $( 'nav-container .fixed-nav .menu-primary' ).css( {'max-height' : '0'} );
        }

        if( $(window).width() < 960 ){
            if( !$( '.header-wrapper' ).hasClass( 'wrapper-flush' ) ){
                $('.header-wrapper').addClass('wrapper-flush');
            }
        } else{
            if( $( '.header-wrapper' ).hasClass( 'wrapper-flush' ) ){
                $('.header-wrapper').removeClass('wrapper-flush');
            }
        }
    });

    $('.mobile-menu-toggle').on( 'click', function(){
        if( !$('.nav-primary .nav-container').hasClass('menu-open') ){
            $('.nav-primary .nav-container').addClass('menu-open');
            $('.mobile-menu-toggle i').fadeToggle( 100, function(){
                $(this).toggleClass( 'icon-menu icon-close2' );
                $(this).fadeToggle( 100 );
            });
        } else{
            $('.nav-primary .nav-container').removeClass('menu-open');
            $('.mobile-menu-toggle i').fadeToggle( 100, function(){
                $(this).toggleClass( 'icon-menu icon-close2' );
                $(this).fadeToggle( 100 );
            });

            /* CLose Sub-menus */
            if( $('.nav-primary .menu-primary .menu-item-has-children .sub-menu').hasClass( 'sub-open' ) ){
                $(this).removeClass('sub-open');
            }
        }
    });

    if( $(window).width() <= 960 ){
        $('.nav-primary .menu-primary li.menu-item-has-children').on( 'click touch', function(event){
            $( this ).addClass( 'menu-parent-open' );
            $( this ).siblings().removeClass( 'menu-parent-open' );
            $(this).siblings().children('.sub-menu.sub-open').removeClass( 'sub-open' );
            $(this).children('.sub-menu').toggleClass( 'sub-open' );
            if( $(this).children('.sub-menu').hasClass('sub-open') ){
                event.preventDefault();
            }
        });
    }

    $(window).on('resize', function(event){
        if( $(window).width() > 960 ){
            $('.nav-primary .menu-primary .menu-item-has-children .sub-menu.sub-open').removeClass( 'sub-open' );
        }
    });

    /* AJAX
    ---------------------------------------- */

    $('#load-more').on('click', function(){

        var page_num = parseInt( $( '#load-more').attr('data-pagenum') ) + 1;

        $.ajax({
            type: 'GET',
            url: ajaxvars.ajaxurl,
            data: {
                action: 'load_more_stories',
                page_num: page_num,
                cat_term: ajaxvars.catTerm
            },
            dataType: 'json',
            beforeSend: function() {
                $( '#ajax-loader' ).show();
            },
            success: function(reply) {
                console.log(reply);
                if( reply.success ){
                    $('.news-list').append( reply.posts );
                    $( '#load-more').attr('data-pagenum',  page_num);
                } else{
                    $( '#load-more' ).hide();
                    $( '.news-list' ).append( "<h3 class=\"no-more-stories\"><span>Sorry, no more stories</span></h3>" );
                }
            },
            complete: function(){
                $( '#ajax-loader' ).hide();
            }
        });

    });

    $('#load-more-search-results').on('click', function(){

        var page_num = parseInt( $( '#load-more-search-results').attr('data-pagenum') ) + 1;

        $.ajax({
            type: 'GET',
            url: ajaxvars.ajaxurl,
            data: {
                action: 'load_more_search_results',
                search_query: ajaxvars.search_query,
                page_num: page_num,
            },
            dataType: 'json',
            beforeSend: function() {
                $( '#ajax-loader' ).show();
            },
            success: function(reply) {
                console.log(reply);
                if( reply.success ){
                    $('.news-list').append( reply.posts );
                    $( '#load-more-search-results').attr('data-pagenum',  page_num);
                } else{
                    $( '#load-more-search-results' ).hide();
                    $( '.news-list' ).append( "<h3 class=\"no-more-stories\"><span>Sorry, no more search results</span></h3>" );
                }
            },
            complete: function(){
                $( '#ajax-loader' ).hide();
            }
        });

    });

    $('#filter-events').on('click', function(){

        var search_keyword = $( '#keyword' ).val();
        var search_cat = $( '#event-category' ).val();
        var search_time = $( '#event-time' ).val();

        $.ajax({
            type: 'GET',
            url: ajaxvars.ajaxurl,
            data: {
                action: 'filter_events',
                keyword: search_keyword,
                cat: search_cat,
                daterange: search_time
            },
            dataType: 'json',
            beforeSend: function() {
                $( '.event-list' ).hide();
                $( '#ajax-loader' ).show();
            },
            success: function(reply) {
                console.log(reply);
                if( reply.success ){
                    $('.event-list .event-grid').html( reply.posts );
                    $('.event-list').show();

                    // Set current filter to data attributes
                    $( '#load-more-events').attr( 'data-keyword', search_keyword );
                    $( '#load-more-events').attr( 'data-cat', search_cat );
                    $( '#load-more-events').attr( 'data-time', search_time );
                    $( '#load-more-events').attr( 'data-pagenum', '1');
                } else{
                    $( '#load-more-events' ).hide();
                    $( '.event-list .event-grid' ).html( "<h3 class=\"no-more-events\"><span>Sorry, there are no events matching your search criteria</span></h3>" );
                    $('.event-list').show();
                }
            },
            complete: function(){
                $( '#ajax-loader' ).hide();
                $( '#load-more-events' ).show();
            }
        });

    });

    $('#load-more-events').on('click', function(){

        var page_num = parseInt( $( '#load-more-events').attr('data-pagenum') ) + 1;
        var search_keyword = $( '#load-more-events').attr('data-keyword');
        var search_cat = $( '#load-more-events').attr('data-cat');
        var search_time = $( '#load-more-events').attr('data-time');

        $.ajax({
            type: 'GET',
            url: ajaxvars.ajaxurl,
            data: {
                action: 'load_more_events',
                page_num: page_num,
                keyword: search_keyword,
                cat: search_cat,
                daterange: search_time
            },
            dataType: 'json',
            beforeSend: function() {
                $( '.event-list' ).hide();
                $( '#ajax-loader' ).show();
            },
            success: function(reply) {
                console.log(reply);
                if( reply.success ){
                    $('.event-list .event-grid').append( reply.posts );
                    $('.event-list').show();
                    $( '#load-more-events').attr('data-pagenum',  page_num);
                } else{
                    $( '#load-more-events' ).hide();
                    $( '.event-list .event-grid' ).append( "<h3 class=\"no-more-events\"><span>Sorry, no more events from this search criteria</span></h3>" );
                     $('.event-list').show();
                }
            },
            complete: function(){
                $( '#ajax-loader' ).hide();
            }
        });

    });

    /* Placeholder fix
    ---------------------------------------- */
    $('input, textarea').placeholder();
    
    /* Cookie Info
    ---------------------------------------- */
    if ($.cookie('cookiesAcknowledged') != 'true'){
        $('#cookie-info').fadeTo(500, 1);
    }
     
    $('#cookie-info #cookie-close').click(function() {
        $('#cookie-info').fadeOut(500);
        $.cookie('cookiesAcknowledged', true, { expires: 168, path: '/'});
    });
    
});